import { defineComponent, computed } from '@vue/composition-api';

var externalPrefixes = [
    "http:", "https:", "mailto:", "tel:",
    "viber:", "whatsapp:", "slack:", "skype:",
    "sms:", "tg:", "fb-messenger:", "instagram:",
    "tiktok:", "twitter:", "x:", "linkedin:",
    "snapchat:", "discord:", "messenger:", "wechat:",
    "line:", "signal:", "pinterest:", "reddit:"
];
function isExternal(url) {
    return typeof url === 'string' && externalPrefixes.some(function (prefix) { return url.startsWith(prefix); });
}
// Current router-link component does not support navigate and emit functionality.
// Workaround implemented in the shell is having .native modifier on @click to have additional click callback along with the native SPA navigation.
// Unfortunately if the component that is using the router-link has to re-emit towards its parent this workaround does not work since the navigation is triggered before the event is re-emitted.
// This does not seem to be the case with Vue 3 / new vue-router and this component can be simplified substantially once we transition.
var script = defineComponent({
    name: 'SdsLink',
    props: {
        to: {
            type: [String, Object],
            required: true,
        },
        exact: {
            type: Boolean,
            required: false,
            default: false,
        },
        exactPath: {
            type: Boolean,
            required: false,
            default: false,
        },
        append: {
            type: Boolean,
            required: false,
            default: false,
        },
        replace: {
            type: Boolean,
            required: false,
            default: false,
        },
        activeClass: {
            type: String,
            required: false,
            default: undefined,
        },
        exactActiveClass: {
            type: String,
            required: false,
            default: undefined,
        },
        ariaCurrentValue: {
            type: String,
            required: false,
            default: 'page',
        },
        dataTestId: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    emits: ['click'],
    setup: function (props, _a) {
        var emit = _a.emit;
        var isExternalLink = computed(function () { return isExternal(props.to); });
        var handleClick = function (event, navigate) {
            navigate(event);
            emit('click', event);
        };
        return {
            isExternalLink: isExternalLink,
            handleClick: handleClick,
        };
    },
});

export default script;
